import { SimpleGrid, Skeleton, Stack } from '@chakra-ui/react';

const BrandSkeleton = () => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap='5'>
      {Array.from({ length: 4 }).map((_, index) => (
        <Stack gap={4} key={`shipper-skeleton-${index}`}>
          <Skeleton height='175px' rounded='24px' />
          <Skeleton height='18px' width='80%' />
          <Skeleton height='18px' width='60%' />
        </Stack>
      ))}
    </SimpleGrid>
  );
};

export default BrandSkeleton;
